import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AddCompetitionPricing = () => {
  const [examCategories, setExamCategories] = useState([]);
  const [examCategoryId, setExamCategoryId] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [price, setPrice] = useState();

  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };
  const handleAddPrice = () => {
    navigate("/exam-notes-pricing/add-competition-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/exam-notes-pricing/all-competition-pricing");
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/competitions`)
      .then((response) => {
        const examCategoriesData = response.data?.data || [];
        setExamCategories(examCategoriesData);
      })
      .catch((error) => console.log(error));
  }, []);

  const payload = {
    competitionId: examCategoryId,
    price,
    type: "competition",
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}/admin/pricing/exam-notes`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Competition exam notes price added.");
        navigate("/exam-notes-pricing/all-competition-pricing");
      })
      .catch((error) => {
        console.log(error);
        alert(error?.response?.data?.message);
      });
  };
  return (
    <div id="exam-competitive-notes-inner-wrapper">
      <div className="competitive-main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            marginLeft: "10px",
            fontSize: "25px",
            color: "#000",
          }}
        />
        <div className="competitive-header-div">
          <h5>Competition Exam Notes Pricing</h5>

          <div className="competitive-btn-group">
            <button
              className="addNewCompetitiveNoteBtn"
              onClick={handleAddPrice}
            >
              + Add Price
            </button>
            <button
              className="viewAllCompetitiveNotesBtn"
              onClick={handleViewAllPrice}
            >
              All Price
            </button>
          </div>
        </div>

        <div className="competitive-form-container" id="form">
          <h4 className="competitive-note-detail">Add Price</h4>
          <form
            onSubmit={handleSubmit}
            className="competitive-note-detail-form"
          >
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Exam Category</label>
              <select
                className="new-chapter-dropdown"
                value={examCategoryId}
                onChange={(e) => setExamCategoryId(e.target.value)}
                required
              >
                <option value="">-Select Category-</option>
                {examCategories.map((examCategory, idx) => (
                  <option key={idx} value={examCategory._id}>
                    {examCategory.examCategory}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Price</label>
              <input
                type="text"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Price"
                required
              />
            </div>

            <div className="competitive-form-btns">
              <button className="competitive-btn-save" type="submit">
                Save
              </button>
              <button className="competitive-btn-cancel" type="button">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCompetitionPricing;
